module.exports = __webpack_public_path__ + "static/media/anim_hover.5db44972.svg";